exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-back {\n  min-height: 100vh;\n  min-width: 100vw;\n  background: #6eb5da;\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(18%, #6eb5da), color-stop(40%, #589ac9), color-stop(62%, #2b6da8), color-stop(79%, #1b437b));\n  background: linear-gradient(180deg, #6eb5da 18%, #589ac9 40%, #2b6da8 62%, #1b437b 79%); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main